import {
  IsBoolean,
  IsDate,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
  Max,
} from 'class-validator';

export const MAX_VACATIONS_SEARCH = 30;

export class SearchVacationsDto {
  @IsOptional()
  @IsNumber()
  @Max(MAX_VACATIONS_SEARCH)
  take?: number;

  @IsOptional()
  @IsNumber()
  skip?: number;

  @IsOptional()
  @IsUUID()
  userId?: string;

  @IsOptional()
  @IsBoolean()
  hidePast?: boolean;
}

export class CreateVacationDto {
  @IsDate()
  fromDate: Date;

  @IsDate()
  untilDate: Date;

  @IsOptional() // Defaults to current user
  @IsUUID()
  userId?: string;
}

export class UpdateVacationDto {
  @IsOptional()
  @IsDate()
  fromDate?: Date;

  @IsOptional()
  @IsDate()
  untilDate?: Date;
}

export class VacationDto {
  @IsString()
  id: string;

  @IsDate()
  fromDate: Date;

  @IsDate()
  untilDate: Date;
}
